import { Component, Host, h, Prop, Watch, State } from '@stencil/core';

interface UiCmsQualitySealBody {
  variant: number;
  language: 'de' | 'fr' | 'en';
}

@Component({
  tag: 'ui-cms-quality-seal',
  styleUrl: 'ui-cms-quality-seal.scss',
  shadow: true,
})
export class UiCmsQualitySeal {
  @Prop({ mutable: true }) body: UiCmsQualitySealBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  /**
   * path to the folder where the svgs are located
   */
  @Prop() qualitySealPath =
    'https://global-resources.dev.fe.union-investment.de/integration/assets/img/logos/objektseiten/';

  /**
   * represents the quality seal as SVG string
   */
  @State() qualitySeal: string;

  variantMap = [
    { markenformColor: 'blue', logoColor: 'white' },
    { markenformColor: 'white', logoColor: 'blue' },
    { markenformColor: 'primary', logoColor: 'blue' },
    { markenformColor: 'primary', logoColor: 'white' },
  ];

  fetchQualitySealSvg() {
    const { language } = this.body;
    if (language) {
      const url = `${this.qualitySealPath}ui-ownership-${language}.svg`;
      fetch(url)
        .then((res) => {
          if (!res.ok) {
            this.qualitySeal = '';
            throw new Error(res.statusText);
          }
          return res.text();
        })
        .then((svg) => {
          this.qualitySeal = svg;
        })
        .catch((err) => console.log(err));
    }
  }

  getQualitySealColors(variant: number) {
    return this.variantMap[variant || 0];
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    this.fetchQualitySealSvg();
  }

  render() {
    const { variant } = this.body;
    const { logoColor, markenformColor } = this.getQualitySealColors(variant);

    return (
      <Host>
        <div
          class={{
            'ui-cms-quality-seal': true,
            [`ui-cms-quality-seal__markenform--${markenformColor}`]: true,
            [`ui-cms-quality-seal__logo--${logoColor}`]: true,
          }}
          innerHTML={this.qualitySeal}
        ></div>
      </Host>
    );
  }
}
